import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      component: () => import('@/views/index')
    },
    {
      path: '/cooperation',
      component: () => import('@/views/cooperation')
    },
    {
      path: '/business',
      component: () => import('@/views/business')
    },
    {
      path: '/about',
      component: () => import('@/views/about')
    },
    {
      path: '/cooperationA',
      component: () => import('@/views/cooperationA')
    },
    {
      path: '/contact',
      component: () => import('@/views/contact')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js